import { define, generateTestIdObject } from '../../utils';

const PAGE_NAME = 'qset-review-task-detail';

const ELEMENTS = define({
  // `QSetReviewStatusTag` renders a plain `Label` with no role, and the same
  // four texts (Todo / In Review / Reviewed / Done) also render on every
  // subtask card further down the page, so matching by text alone is
  // ambiguous. Applied at the `MainTaskPageHeader` call site only.
  STATUS_TAG: ['status', 'tag'],
  // The owner's action for a reviewed subtask. Its label is also the title and
  // the accept button of the confirmation modal it opens, so role + name
  // resolves three elements at once. Menu items are portalled and only exist
  // while the menu is open, so this id is unambiguous even with several
  // subtasks on the page.
  MARK_AS_DONE_MENU_ITEM: ['mark-as-done', 'menuitem'],
  // Both are asserted absent, so neither should hinge on a label.
  START_REVIEW_MENU_ITEM: ['start-review', 'menuitem'],
  CHANGE_REVIEWER_MENU_ITEM: ['change-reviewer', 'menuitem'],
});

export const QSET_REVIEW_TASK_DETAIL_DATA_TEST_ID = generateTestIdObject(PAGE_NAME, ELEMENTS);
